import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { caseStudiesData } from '../mockData';

const PortfolioSection = () => {
  return (
    <section className="py-32 bg-white" data-testid="portfolio-section">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-20 max-w-3xl mx-auto"
        >
          <span className="inline-block text-sm font-medium text-[#C8102E] uppercase tracking-widest mb-4">
            Case Studies
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A1A1A] mb-6 tracking-tight">
            Recent projects
          </h2>
          <p className="text-lg md:text-xl text-gray-500 leading-relaxed">
            Real Singapore businesses that launched their brand, website, SEO and social in one Growth Bundle at <strong className="text-[#1A1A1A]">S$3,999</strong>.
          </p>
        </motion.div>

        {/* Portfolio Grid — 4 real case studies */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {caseStudiesData.map((project, index) => (
            <motion.div
              key={project.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.08 }}
              viewport={{ once: true }}
              data-testid={`portfolio-item-${project.slug}`}
            >
              <Link to={`/case-studies/${project.slug}`} className="group block">
                {/* Image */}
                <div className="relative overflow-hidden rounded-3xl bg-[#FAFAFA] aspect-[4/3] mb-5">
                  <motion.img
                    src={project.thumbnail}
                    alt={`${project.title} — ${project.industry} case study by Hei Web Creations Singapore`}
                    loading="lazy"
                    className="w-full h-full object-cover"
                    whileHover={{ scale: 1.06 }}
                    transition={{ duration: 0.6, ease: [0.6, 0.05, 0.01, 0.9] }}
                  />
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur rounded-full px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#1A1A1A]">
                    {project.package}
                  </div>
                  <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/20 transition-all duration-500 flex items-center justify-center">
                    <motion.div
                      initial={{ opacity: 0, scale: 0.8 }}
                      className="w-14 h-14 rounded-full bg-white flex items-center justify-center opacity-0 group-hover:opacity-100 scale-90 group-hover:scale-100 transition-all duration-500"
                    >
                      <ArrowUpRight className="text-[#1A1A1A]" size={24} />
                    </motion.div>
                  </div>
                </div>

                {/* Text */}
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-[#1A1A1A] group-hover:text-[#C8102E] transition-colors duration-300">
                      {project.title}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      {project.industry} · {project.services.slice(0, 3).join(' · ')}
                    </p>
                  </div>
                  <ArrowUpRight
                    size={22}
                    className="text-gray-300 group-hover:text-[#C8102E] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300 mt-1 flex-shrink-0"
                  />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
